// The expo-file-system/legacy calls services/ make, on the web.
// "File URIs" are blob: object URLs from a file picker (see src/lib/files.js);
// cache files are kept in memory until Share (react-native shim) downloads them.
export const cacheDirectory = "memory://cache/";
export const FileSystemUploadType = { BINARY_CONTENT: 0, MULTIPART: 1 };

const memory = new Map();

export function takeFile(uri) {
  const file = memory.get(uri);
  memory.delete(uri);
  return file || null;
}

export async function writeAsStringAsync(uri, contents) {
  memory.set(uri, { contents });
}

export async function deleteAsync(uri) {
  memory.delete(uri);
}

async function readBlob(uri) {
  const res = await fetch(uri);
  if (!res.ok) throw new Error(`Could not read file (${res.status})`);
  return res.blob();
}

export async function getInfoAsync(uri) {
  if (memory.has(uri)) return { exists: true, size: memory.get(uri).contents.length };
  try {
    const blob = await readBlob(uri);
    return { exists: true, size: blob.size };
  } catch {
    return { exists: false };
  }
}

export async function readAsStringAsync(uri, { encoding } = {}) {
  const blob = await readBlob(uri);
  if (encoding !== "base64") return blob.text();
  const bytes = new Uint8Array(await blob.arrayBuffer());
  let binary = "";
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  }
  return btoa(binary);
}

// Same contract as expo: uploadAsync() resolves { status, body }, or undefined
// once cancelAsync() ran.
export function createUploadTask(url, fileUri, { httpMethod = "POST", headers = {} } = {}) {
  const controller = new AbortController();
  return {
    async uploadAsync() {
      try {
        const blob = await readBlob(fileUri);
        const res = await fetch(url, { method: httpMethod, headers, body: blob, signal: controller.signal });
        return { status: res.status, body: await res.text() };
      } catch (e) {
        if (controller.signal.aborted) return undefined;
        throw e;
      }
    },
    async cancelAsync() { controller.abort(); },
  };
}

export async function uploadAsync(url, fileUri, options) {
  return createUploadTask(url, fileUri, options).uploadAsync();
}
